import { icon } from './icons';

// Accessible accordion
export type FaqItem = readonly [question: string, answerHtml: string];

export function faqAccordion(items: readonly FaqItem[], idp = 'faq'): string {
  return `<div class="faq" data-accordion>${items
    .map(
      ([q, a], i) => `
    <div class="faq-item">
      <h3><button class="faq-btn" id="${idp}-b${i}" aria-expanded="false" aria-controls="${idp}-p${i}"><span>${q}</span><span class="pm">${icon('plus')}</span></button></h3>
      <div class="faq-panel" id="${idp}-p${i}" role="region" aria-labelledby="${idp}-b${i}"><div><div class="faq-a">${a}</div></div></div>
    </div>`,
    )
    .join('')}</div>`;
}
